import { AccountOption } from 'src/app/pages/account-register/models/account-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const accountOptionActions = createEagerSelectActions<AccountOption>('[Account Options]');
